<template>
  <el-form ref="dayForm" :model="tableData" :rules="rules" class="day">
    <div class="day__header">
      <div class="day__header-title-wrapper">
        <svg-icon name="arrow-left" class="day__header-arrow" />
        <p class="day__header-title">{{ day[0] }}</p>
      </div>
      <p class="day__header-delete">Удалить</p>
    </div>
    <el-row :gutter="20">
      <el-col :md="19">
        <el-form-item label="Название дня">
          <el-input v-model="tableData.day" />
        </el-form-item>
      </el-col>
      <el-col :md="5"></el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="19">
        <el-form-item label="Общее количество очков основных заданий">
          <el-input v-model="tableData.score" />
        </el-form-item>
      </el-col>
      <el-col :md="5"></el-col>
    </el-row>
    <el-row :gutter="20" type="flex" align="top" justify="start">
      <el-col :md="19">
        <el-form-item label="Основное задание">
          <el-input v-model="tableData.mainTask" />
        </el-form-item>
        <a href="#" class="day__add-btn hidden-md-and-up" @click.prevent="addModule('main')">
          <svg-icon name="plus" class="day__plus-icon" />
          Добавить
        </a>
        <ul class="day__module">
          <li
            v-for="(item, index) in mainDaysData"
            :key="index"
            class="day__module-item"
            @mouseover="isEditable = index"
            @mouseleave="isEditable = null"
          >
            <span>{{ item }}</span>
            <div
              :class="[
                'day__module-item-editable',
                isEditable === index ? 'is-editable-active' : ''
              ]"
            >
              <svg-icon
                name="pencil"
                class="day__module-item-edit"
                @click="editModuleItem(index)"
              />
              <svg-icon
                name="times"
                class="day__module-item-delete"
                @click="deleteModuleItem(index)"
              />
            </div>
          </li>
        </ul>
      </el-col>
      <el-col :md="5" class="hidden-sm-and-down">
        <a href="#" class="day__add-btn" @click.prevent="addModule('main')">
          <svg-icon name="plus" class="day__plus-icon" />
          Добавить
        </a>
      </el-col>
    </el-row>
    <el-row :gutter="20" type="flex" align="top" justify="start">
      <el-col :md="19">
        <el-form-item label="Дополнительное задание">
          <el-input v-model="tableData.extraTask" />
        </el-form-item>
        <a href="#" class="day__add-btn hidden-md-and-up" @click.prevent="addModule('extra')">
          <svg-icon name="plus" class="day__plus-icon" />
          Добавить
        </a>
        <ul class="day__module">
          <li
            v-for="(item, index) in extraDaysData"
            :key="index"
            class="day__module-item"
            @mouseover="isEditable = index"
            @mouseleave="isEditable = null"
          >
            <span>{{ item }}</span>
            <div
              :class="[
                'day__module-item-editable',
                isEditable === index ? 'is-editable-active' : ''
              ]"
            >
              <svg-icon
                name="pencil"
                class="day__module-item-edit"
                @click="editModuleItem(index)"
              />
              <svg-icon
                name="times"
                class="day__module-item-delete"
                @click="deleteModuleItem(index)"
              />
            </div>
          </li>
        </ul>
      </el-col>
      <el-col :md="5" class="hidden-sm-and-down">
        <a href="#" class="day__add-btn" @click.prevent="addModule('extra')">
          <svg-icon name="plus" class="day__plus-icon" />
          Добавить
        </a>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'OverviewDays',
  props: {
    formModel: {
      type: Object,
      required: true
    },
    courseData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {},
      isEditable: null,
      tableData: {}
    }
  },
  computed: {
    mainDaysData() {
      return this.moduleData.children[0].children.map(item => item.task)
    },

    extraDaysData() {
      return this.moduleData.children[1].children.map(item => item.task)
    },

    day() {
      const { day } = this.$route.params.day
      return day.split('.')
    },

    moduleData() {
      return this.$route.params.day
    }
  },
  mounted() {
    this.getDaysData()
  },
  methods: {
    editModuleItem(index) {
      this.courseData.data[1].children = this.moduleData[index]
    },

    deleteModuleItem(index) {
      this.moduleData.children[0].children[0].children.splice(index, 1)
    },

    addModule(module) {
      if (!this.tableData.day) {
        return
      }

      if (module === 'main') {
        this.moduleData.children[0].children[0].children.push({
          task: this.tableData.mainTask
        })
      } else {
        this.moduleData.children[0].children[1].children.push({
          task: this.tableData.extraTask
        })
      }
    },
    getDaysData() {
      this.tableData = {
        day: this.day[1],
        score: '80'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.day {
  &__plus-icon {
    height: 20px;
    width: 20px;
    stroke: $luchmara;
  }

  &__add-btn {
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-top: 34px;
    font-size: 16px;
    color: $luchmara;

    @include sm-and-down {
      margin: 16px 0;
    }

    svg {
      margin-right: 10px;
    }
  }

  &__module {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 15px;
    color: $deepdark;
  }

  &__module-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    padding: 8px;
    min-width: 170px;
    border: 1px solid $whisper;
    border-radius: 4px;
    cursor: pointer;

    @include sm-and-down {
      min-width: 100%;
    }

    &-edit,
    &-delete {
      width: 18px;
      height: 18px;
    }

    &-edit {
      margin-right: 10px;
      stroke: $luchmara;
    }

    &-delete {
      stroke: $red;
    }

    &-editable {
      display: flex;
      visibility: hidden;
      opacity: 0;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;

    @include sm-and-down {
      align-items: center;
    }
  }

  &__header-delete {
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 0.2px;
    color: $red;
    cursor: pointer;
  }

  &__header-title {
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.35px;
    color: $deepdark;

    &-wrapper {
      display: flex;
      align-items: center;
    }
  }

  &__header-arrow {
    margin-right: 16px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.el-select {
  width: 100% !important;
}

.is-editable-active {
  opacity: 1;
  visibility: visible;
  transition: opacity 1s ease-in-out;
}

::v-deep .el-form-item__label {
  display: flex;
  margin-bottom: 4px;
  padding-left: 6px;
  font-size: 12px;
  text-align: left;
  line-height: 20px;
  color: #b6b9c3;
}
</style>
